import { NgModule } from '@angular/core';

import { RatingTableComponent } from "./rating-table.component";
import { CommonModule } from "@angular/common";
import { MatTableModule } from "@angular/material/table";
import { DirectionsModule } from "libraries/component/booking-information/components/sectors/components/sectors-air/sector-air-summary/components/directions.module";
import { ThTextModule } from "libraries/component/table/th-text/th-text.module";
import { TdTextModule } from "libraries/component/table/td-text/td-text.module";
import { ConfigurationResourceModule } from "libraries/service/resources/configuration/configurationResource.module";
import { LocalizedModule } from "../../pipes/localized/localized.module";
import { RatingNotationModule } from "../rating-notation/rating-notation.module";
import { FindAirportPipe } from "./find-airport.pipe";
import { CarbonFootprintModule } from "../carbon-footprint/carbon-footprint.module";
import { FindDetailPipe } from "./find-detail.pipe";
import { FindCarrierPipe } from "./find-carrier.pipe";
import { GetNoDoubleCarrierCodePipe } from "./get-no-double-carrier-code.pipe";
import { StopsModule } from "../stops/stops.module";
import { MapPipeModule } from "libraries/pipes/map/map-pipe.module";
import { RatingShapeModule } from "libraries/component/rating-shape/rating-shape.module";

@NgModule({
    imports: [
        CarbonFootprintModule,
        CommonModule,
        ConfigurationResourceModule,
        DirectionsModule,
        LocalizedModule,
        MapPipeModule,
        MatTableModule,
        RatingNotationModule,
        RatingShapeModule,
        StopsModule,
        TdTextModule,
        ThTextModule,
    ],
    exports: [
        RatingTableComponent,
        FindAirportPipe,
        FindDetailPipe,
        FindCarrierPipe,
        GetNoDoubleCarrierCodePipe,
    ],
    declarations: [
        RatingTableComponent,
        FindAirportPipe,
        FindDetailPipe,
        FindCarrierPipe,
        GetNoDoubleCarrierCodePipe,
    ],
})
export class RatingTableModule {
}
